export default __webpack_public_path__ + "static/media/ic_addons.bc4efd1c.svg";